import { render, staticRenderFns } from "./Exporturi.vue?vue&type=template&id=4595ec24&scoped=true"
import script from "./Exporturi.vue?vue&type=script&lang=js"
export * from "./Exporturi.vue?vue&type=script&lang=js"
import style0 from "./Exporturi.vue?vue&type=style&index=0&id=4595ec24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4595ec24",
  null
  
)

export default component.exports